import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  labels: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  datasets: PropTypes.arrayOf(PropTypes.shape({})),
  chartType: PropTypes.string
};

const defaultProps = {
  labels: [],
  datasets: [],
  chartType: 'Line'
};

const ChartJsGraph = () => {
  // Removed as 
  // - this page is not used anymore.
  // - to remove chart js and thereby reducing js bundle size.
  return <div></div>
};

ChartJsGraph.propTypes = propTypes;
ChartJsGraph.defaultProps = defaultProps;

export default ChartJsGraph;
